import React from 'react';
import Notes from './steps/notes';
import Particulars from './steps/particulars';

import l10n from './localization';
import Form from '../form';

import { 
    PAYMENT_METHOD,
    STRIKABLE_PAYMENT_METHODS
} from './const';

import { shouldVerifyPersonalIdentity } from './utils';

export const localization = l10n;

export const inputSteps = [
    Notes,
    Particulars,
];

export const Intro = () => {
    return (
        <>
            <p />
        </>
    );
}

export const additionalDoc = (localization) => (
    localization.acknowledgementWarning()
);

export const form = {
    steps: inputSteps,
    screenId: "LROLS1",
    code: "LROLS1",
    displayReference: "LR/OLS/1 (06/2024)", 
    reference: "LR/OLS/1 (06/2024)",
    validFrom: "2021/09/22",
    intro: Intro,
    localization: localization,
    signRequired: true,
    emeRequired: true,
    additionalNotes: additionalDoc,
    submitDateId: formData => "Signature Date 簽署日期",
    signDeclaration: formData => localization.owner_notes(formData),
    // signFields: formData => ["SignMain"],
    verifySignIdNumId: (formData) => shouldVerifyPersonalIdentity(formData) ? "BR_CR_PI_PN" : null,
    verifySignNameId: (formData) => shouldVerifyPersonalIdentity(formData) ? "SubscriberName" : null,
    signFields: formData => !formData.SubscriberType || formData.SubscriberType === "0" ? ["SignMain"] : ["SignOrg"],
    signLabelTransparent: true,
    paymentRequired: true, 
    paymentMethodId: "ModeOfPayment",
    paymentAmountId: "FeesAndDeposits", // Don't set it empty, batch job will use this parameter
    offlinePaymentList: "offlinePaymentList",
    acknowledgementWarning: () => localization.acknowledgementWarning(),
    resumeFromStepIdx: 2,
    resumeRetainFormDataKeys: [ 
                                "termsAndConditions",
                                "PICS",
                                "ackEmail",
                                "receiveAckEmail",
                            ],
    submitTransformFunc: (formData, dispatch) => {
        // mutate formDetail and return for submission here
        // if order option is not "CD", then change all form data keys to start with "license."
        // in order to fill the form details to the License order form page.
        let newFormData = {...formData};
        newFormData.DepositHK = newFormData.DepositAmount ? "Yes" : undefined;
        newFormData.PaymentOrderNo = formData.CDChequeOrBankDraftNo;

        // Payment method
        const keepAllMask = () => (STRIKABLE_PAYMENT_METHODS.map(key => `Payment_${key}$strike`).reduce((acc, curr)=>({...acc, [curr]: 'keep'}), {}));
        const strikeMask = (...keys) => (keys.map(key => `Payment_${key}$strike`).reduce((acc, curr)=>({...acc, [curr]: 'strike'}), {}));
        const markOnlineMask = (isOnline) => ({PaymentMethod: isOnline ? 'Online' : 'Cheque Or Bank Draft'});
        const markAmountMask = (amount, isOnline) => ({FeesAndDepositsCheque: !isOnline ? amount : '', FeesAndDepositsOnline: isOnline ? amount : '', ...markOnlineMask(isOnline)});

        const markGcisPayment = (formData, amount) => ({...formData, ...keepAllMask(), ...strikeMask(PAYMENT_METHOD.E_CHEQUE), ...markAmountMask(amount, true)});
        const markECheque = (formData, amount) => ({...formData, ...keepAllMask(), ...strikeMask(PAYMENT_METHOD.PPS, PAYMENT_METHOD.FPS, PAYMENT_METHOD.CREDIT_CARD, PAYMENT_METHOD.MOBILE_WALLET), ...markAmountMask(amount, true)});
        const markBankDraft = (formData, amount) => ({...formData, ...keepAllMask(), ...strikeMask(PAYMENT_METHOD.CHEQUE), ...markAmountMask(amount, false)});
        const markCheque = (formData, amount) => ({...formData, ...keepAllMask(), ...strikeMask(PAYMENT_METHOD.BANK_DRAFT), ...markAmountMask(amount, false)});
        const keepAll = (formData) => ({...formData, ...keepAllMask()});

        const amount = formData['FeesAndDeposits'];
        switch(formData["ModeOfPayment"]){
            case '-2':
                newFormData = markGcisPayment(newFormData, amount);
                break;
            case '-1':
                newFormData = markECheque(newFormData, amount);
                break;
            case '0':
                newFormData = markCheque(newFormData, amount);
                break;
            case '1':
                newFormData = markBankDraft(newFormData, amount);
                break;
            default:
                newFormData = keepAll(newFormData);
                break;
        }

        return newFormData;
    }
}

export default ({currentLang}) => <Form form={form} currentLang={currentLang} />;